module.exports = "/packs/media/images/InvestmentMixPie-753b688c32b9c154a3aa1d8679e3ba50.png";